import { useContext, useEffect } from 'react';
import { ConfigurationCanvasContext } from './ConfigurationCanvasContext';
import { ConfigurationCanvasProps } from './types';

export const WithConfigurationCanvas = ({
  children,
  onStageGateClick,
  readOnly,
  onFunnelLabelClick,
  onFunnelLabelPillClick,
  onFunnelStepClick,
  onRecordTypeLabelClick,
  onRecordTypeLabelPillClick,
  onRecordTypeStepClick,
  visibilityElements,
  selectedGateId,
  selectedStageId,
  selectedFunnelId,
}: ConfigurationCanvasProps & {
  children: React.ReactNode;
}) => {
  const { setConfigurationCanvasProps } = useContext(ConfigurationCanvasContext);

  useEffect(() => {
    setConfigurationCanvasProps({
      onStageGateClick,
      readOnly,
      onFunnelLabelClick,
      onFunnelStepClick,
      onFunnelLabelPillClick,
      onRecordTypeLabelClick,
      onRecordTypeLabelPillClick,
      onRecordTypeStepClick,
      visibilityElements,
      selectedGateId,
      selectedStageId,
      selectedFunnelId,
    });
  }, [
    readOnly,
    setConfigurationCanvasProps,
    onFunnelLabelClick,
    onFunnelStepClick,
    onRecordTypeLabelClick,
    onFunnelLabelPillClick,
    onRecordTypeLabelPillClick,
    onRecordTypeStepClick,
    visibilityElements,
    onStageGateClick,
    selectedGateId,
    selectedStageId,
    selectedFunnelId,
  ]);

  return children;
};
